// import Vue from "vue";

import myUpload from "@/componentsMy/my-upload.vue"
import myUploadOss from "@/componentsMy/my-upload-oss.vue"
// import myMessageSend from "@/componentsMy/my-message-send.vue"
import myMessageTip from "@/componentsMy/my-message-tip.vue"
// import { MessageSend } from "@/componentsMy/my-message-send.js"
import { MessageTip } from "@/componentsMy/my-message-tip.js"
import WsCustomerService from "@/components/WsCustomerService.vue"
export const setComponent = (vue) => {
    vue.component("my-upload", myUpload);
    vue.component("my-upload-oss", myUploadOss);
    // vue.component("my-message-send", myMessageSend);
    vue.component("my-message-send", myMessageTip);
    // vue.prototype.MessageSend = MessageSend
    vue.prototype.MessageSend = MessageTip
    vue.component("ws-customer-service", WsCustomerService);
}
